import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { socket } from 'api';
import { user } from 'services/user';
import services from 'services';
import { BlueButton, RedButton } from 'libs/ui';
import { setUnrecognized } from 'store/actions/events';
import { CallButtons } from '../call-buttons/call-buttons';
import { Items } from './items';
import { Content, Title, Buttons, Inner, PlateInfo, VehicleClassInfo, ItemContainer, SectionLabel } from './unrecognized.styled';
import { Plate } from './plate';
import { VehicleClass } from './vehicle-class';

import { Item } from './item';

export const Unrecognized = (props) => {
  const { t } = useTranslation();
  const { data, id } = props;
  const event = data;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const plateMean = event.data?.vehicle_plate_mean;

  const method = event.data?.method === 'vehicle_class_not_match_mean' ? 'vehicle_class_not_match_mean' : 'plateMean';

  const afterSetPlate = () => {
    // props.getData();
    setLoading(false);
  };

  useEffect(() => {
    socket.on('set_vehicle_plate', afterSetPlate);
    socket.on('rack.set_vehicle_class', afterSetPlate);

    return () => {
      socket.off('set_vehicle_plate', afterSetPlate);
      socket.off('rack.set_vehicle_class', afterSetPlate);
    };
  }, []);

  if (!id) {
    return null;
  }

  /**
   * allow ride
   */
  const ok = () => {
    const msg = { target: id, user_id: user.getId() };
    socket.call('allow_payment_mean', msg);
    cancel();
  };

  /**
   * cancel ride
   */
  const cancel = () => {
    socket.call('confirm_event_by_id', { id: event.id });
    dispatch(setUnrecognized(null));
  };

  /**
   * change plate
   * @param {*} value
   */
  const changePlate = (value) => {
    setLoading(true);
    socket.call('set_vehicle_plate', { target: event.source, vehicle_plate: value });
  };

  const changeVehicleClassMean = (value) => {
    setLoading(true);
    socket.call('racks.set_vehicle_class', { target: event.source, vehicle_class: value });

    setLoading(false);
  };

  const changeVehicleClass = (value) => {
    setLoading(true);
    socket.call('racks.set_vehicle_class', { target: event.source, vehicle_class: value });

    setLoading(false);
  };

  const msg = event.message ?? t('messages.номер распознан некорректно');
  const date = services.formatDateTime(event.created_at);

  const isClass = method === 'vehicle_class_not_match_mean';

  return (
    <Content>
      <CallButtons rackId={id} style={{ position: 'absolute', top: '16px', right: '16px' }} small />
      <Title>
        <span className="time">{date}</span>
        {event.source_name && <span className="rack">{event.source_name}</span>}
        <span className="msg">{msg}</span>
      </Title>
      <Inner>
        <SectionLabel>{isClass ? t('windows.Класс ТС') : t('buttons.Контроль ГРЗ')}</SectionLabel>
        {method === 'plateMean' && (
          <>
            <Items event={event} rackId={id} />
            {plateMean && (
              <PlateInfo>
                <Plate disabled title={t('means.ГРЗ в СО')} loading={loading} value={plateMean} change={changePlate} />
              </PlateInfo>
            )}
          </>
        )}

        {isClass && (
          <>
            <ItemContainer>
              <Item id={id} item={event.data} refreshPhotoButton={true} refreshPlateButton={true} source={event.source} />
            </ItemContainer>
            <VehicleClassInfo>
              <VehicleClass
                disabled={true}
                title={t('windows.Класс ТС в СО')}
                loading={loading}
                value={event.data?.vehicle_class_mean}
                change={changeVehicleClassMean}
              />

              <VehicleClass
                disabled={false}
                title={t('windows.Класс ТС')}
                loading={loading}
                value={event.data?.vehicle_class}
                change={changeVehicleClass}
              />
            </VehicleClassInfo>
          </>
        )}
        <Buttons>
          <RedButton className="big" onClick={cancel}>
            <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
            </svg>
            {t('buttons.Запретить')}
          </RedButton>
          <BlueButton className="big" onClick={ok}>
            <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M5 12.5l4.5 4.5L19 7" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            {t('buttons.Разрешить')}
          </BlueButton>
        </Buttons>
      </Inner>
    </Content>
  );
};
